import { useContext } from "react";
import Context from "../context/ContextProvider";

const useStore = () => useContext(Context);

export default useStore;
